export const transformMiddleQuery = (base) => ({
  ...base,
  'max-width-450': {
    maxWidth: 450
  }
});

export const headerQuery = {
  'max-width-570': {
    maxWidth: 570
  },
  'max-width-470': {
    maxWidth: 470
  },
  'max-height-100': {
    maxHeight: 100
  },
  'max-height-74': {
    maxHeight: 74
  }
};
